import qiangzhi from "./shit/qiangzhi.vue";
import fengxian from "./shit/fengxian.vue";
import fuwu from "./shit/fuwu.vue";
import mElectronicFooter from "@/components/mElectronicFooter.vue";
export default {
  components: {
    qiangzhi,
    fengxian,
    fuwu,
    mElectronicFooter
  }
}